// client/src/components/SuggestionsDialog.js

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Checkbox,
  VStack,
  Text,
  Box,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';

export default function SuggestionsDialog({ isOpen, onClose, suggestions, onConfirm,
  initialSelected = []
}) {
  const [checkedItems, setCheckedItems] = useState([]);

  // Initialize checkboxes from selectedSuggestions when dialog opens
  useEffect(() => {
    if (isOpen) {
      setCheckedItems(initialSelected);
    }
  }, [isOpen, initialSelected]);

  const suggestionKeys = Object.keys(suggestions || {});
  const hasNoSuggestions = suggestionKeys.length === 0;

  const handleCheckboxChange = (key, isChecked) => {
    if (isChecked) {
      setCheckedItems(prev => [...prev, key]);
    } else {
      setCheckedItems(prev => prev.filter(item => item !== key));
    }
  };

  const handleConfirm = () => {
    onConfirm(checkedItems);
  };

  const handleClear = () => {
    // Clear all checkboxes locally
    setCheckedItems([]);
  };


  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent alignSelf="center">
        <ModalHeader>Review and approve suggestions for your report</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {hasNoSuggestions ? (
            <Text color="#6D6D6D" textAlign="center" py={20}>
              No suggestions found
            </Text>
          ) : (
            <VStack align="stretch" spacing={4}>
              {suggestionKeys.map((key) => (
                <Box key={key} p={3} border="1px solid #DADADA" borderRadius="md">
                  <Checkbox
                    colorScheme="pink"
                    borderColor="#C4C4C4"
                    isChecked={checkedItems.includes(key)}
                    onChange={(e) => handleCheckboxChange(key, e.target.checked)}
                    mb={2}
                  >
                    <Text fontWeight="semibold" color="#242424">{key}</Text>
                  </Checkbox>
                  <Text fontSize="sm" color="#6D6D6D" ml={6}>
                    {suggestions[key]}
                  </Text>
                </Box>
              ))}
            </VStack>
          )}
        </ModalBody>
       

        <ModalFooter>
          <Button
            mr={3}
            bg="#FFFFFF"
            color="#037A9B"
            border="1px solid #00C2E5"
            borderRadius="12px"
            fontWeight="600"
            _hover={{ bg: '#FFFFFF' }}
            _active={{ bg: '#FFFFFF' }}
            onClick={handleClear}
          >
            Clear
          </Button>

          <Button
            colorScheme="blue"
            bg="#CF008A"
            color="#FFFFFF"
            borderRadius="12px"
            _hover={{ bg: '#CF008A' }}
            _active={{ bg: '#CF008A' }}
            onClick={handleConfirm}
            // isDisabled={checkedItems.length === 0 || hasNoSuggestions}
          >
            Generate Report
            {checkedItems.length > 0 && ` (${checkedItems.length})`}
          </Button>
        </ModalFooter>

      </ModalContent>
    </Modal>
  );
}
